const solutions = (n) => {
  if (n < 3) {
    return `
- Importo Biennale: Euro 1.430,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.900,00 + IVA 22% cadauno
`
  } else if (n < 5) {
    return `
- Importo Biennale: Euro 1.380,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.820,00 + IVA 22% cadauno
`
  } else if (n < 10) {
    return `
- Importo Biennale: Euro 1.310,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.750,00 + IVA 22% cadauno
`
  } else if (n < 20) {
    return `
- Importo Biennale: Euro 1.220,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.620,00 + IVA 22% cadauno
`
  } else {
    return `
- Importo Biennale: Euro 1.150,00 + IVA 22% cadauno
- Importo Triennale: Euro 1.520,00 + IVA 22% cadauno
`
  }
}

const renew = (n) => {
  if (n < 3) {
    return `
1 ANNO a 790,00€ + iva
`
  } else if (n < 5) {
    return `
1 ANNO a 770,00€ + iva
`
  } else if (n < 10) {
    return `
1 ANNO a 720,00€ + iva
`
  } else if (n < 20) {
    return `
1 ANNO a 680,00€ + iva
`
  } else {
    return `
1 ANNO a 630,00€ + iva
`
  }
}

const extraOptions = (n) => {
  if (n < 3) {
    return `
Se lo desidera, può anche dilazionare la spesa in rate da 24 oppure 36 mesi tramite la formula del Noleggio Operativo e addebito tramite RID bancario:

- Importo Biennale: Euro 70,43 + IVA 22% al mese per 24 mesi (importo rateale di una singola licenza).
- Importo Triennale: Euro 66,83  + IVA 22% al mese per 36 mesi (importo rateale di una singola licenza).
`
  } else {
    return `
Se lo desidera, può anche dilazionare la spesa in rate da 24 oppure 36 mesi tramite la formula del Noleggio Operativo e addebito tramite RID bancario.
`
  }
}

const makeEmail = (contact, contracts, productContracts, moment, n) => {
  let contractsText = contracts.map((contract) => {
    let productContract
    if (contract.product_contract) {
      productContract = productContracts.find(function (c) {
        return contract.product_contract === c.id
      })
    } else {
      productContract = {
        amount: "x",
        serial: "x"
      }
    }

    return `Contratto ${contract.type_name} - Qtà: ${productContract.amount} – ${productContract.order}° Chiave Nr: ${productContract.serial}, in scadenza il giorno ${moment(contract.end_date).format("DD/MM/YYYY")}`
  }
  ).join("\n")

  let body = `
Gent. Arch. ${contact.first_name} ${contact.last_name},

vogliamo avvisare che il seguente Contratto Graphisoft Forward a Lei intestato è in scadenza per le seguenti licenze:

${contractsText}

Il contratto verrà rinnovato automaticamente per tutte le licenze in scadenza per la durata di
${renew(n)}
come da Lei indicato in fase di sottoscrizione; qualora volesse modificare la durata del Service Term troverà le condizioni qui di seguito e potrà farlo inviando il modulo allegato ENTRO IL XX/XX/XXXX onde evitare la tacita fatturazione per l’importo sopra indicato.

CONDIZIONI:
${solutions(n)}

Il listino completo è disponibile al seguente link: https://media.archicad.it/moduli/GS_tabella_aggiornamenti.pdf

RINNOVARE IL CONTRATTO DI ASSISTENZA E AGGIORNAMENTO SIGNIFICA MASSIMIZZARE LA PRODUTTIVITA’ E RIDURRE NEL TEMPO L’INVESTIMENTO SUL SOFTWARE.

La fattura verrà emessa da Graphisoft all’inizio di XXXXXX e il pagamento dovrà essere effettuato entro il XX/XX/XXXX con BONIFICO BANCARIO secondo le modalità indicate in fattura.
Se invece preferisce pagare con CARTA DI CREDITO, dovrà farlo presente rispondendo alla presente mail.
Se ha variato i dati di fatturazione, La preghiamo di comunicarceli contestualmente alla conferma del rinnovo del contratto.

${extraOptions(n)}

Se interessato al rinnovo mediante noleggio operativo, La preghiamo di darci conferma alla presente entro il XX/XX/XXXX. Le indicheremo i documenti da inviarci per poter attivare la pratica Grenke.

Può visionare i SERVIZI RISERVATI AGLI UTENTI IN CONTRATTO seguendo questo link: https://graphisoft.com/legal/forward-services-and-benefits/ita

Qualora decidesse di non rinnovare il Contratto Graphisoft Forward di tutte le sue licenze, dovrà far pervenire la disdetta tramite PEC (indicando la motivazione) a OPENVIEW SRL entro il XX/XX/XXXX al seguente indirizzo: openviewsrls@pec.it, onde evitare la tacita fatturazione del rinnovo del contratto prescelto.

Prima di procedere con l’eventuale disdetta, le ricordiamo che i costi di riattivazione da corrispondere oltre al canone del contratto, sono i seguenti:
- Riattivazione (per utenti con la versione più aggiornata): € 400
- Upgrade 1 Step: € 1.300
- Upgrade 2 Step: € 2.600
- Upgrade 3+ Step: € 3.900

Ringraziandola per la fiducia sino ad ora accordata, restiamo a disposizione per ogni ulteriore informazione.
Cordiali saluti.
    `
  return body
}

export default makeEmail
